
import { ref, toRef, onBeforeMount } from 'vue'
import { useStore } from 'vuex'
import { PermissionMap } from '@/utils/auth'

export default {
  name: 'CoverBlock',
  props: {
    title: String,
    src: String,
    data: Object,
    type: String,
    copy: Function,
    del: Function,
    updateStatus: Function,
    edit: Function
  },
  setup (props, { emit }) {
    const store = useStore()
    const isHover = ref(false)
    const current = toRef(props, 'data')
    const coverLock = ref(false)

    const handleDeleteVisible = (e) => {
      coverLock.value = true
    }
    const handleUpdateStatusVisible = (e) => {
      coverLock.value = true
    }
    const handleDelete = () => {
      emit('del')
      coverLock.value = false
    }
    const handleUpdateStatus = () => {
      emit('updateStatus')
      coverLock.value = false
    }
    const handleVisibleChange = (visible) => {
      if (!visible) {
        coverLock.value = false
        isHover.value = false
      }
    }
    onBeforeMount(async () => {
      console.log(121212, current.value.id, props)
    })
    return {
      store,
      current,
      isHover,
      PermissionMap,
      handleDelete,
      handleVisibleChange,
      handleDeleteVisible,
      handleUpdateStatus,
      handleUpdateStatusVisible
    }
  }
}
